export async function retryRequest<T>(
	fn: () => Promise<T>,
	retries: number = 3,
	delay: number = 1000
): Promise<T> {
	let lastError: any;

	for (let attempt = 1; attempt <= retries; attempt++) {
		try {
			return await fn();
		} catch (error) {
			lastError = error;
			if (attempt < retries) {
				await new Promise((res) => setTimeout(res, delay));
			}
		}
	}

	throw lastError;
}
